import BaseModalForm from "./BaseModalForm";

export default class LoginModal extends BaseModalForm {
    get modalElement() {
        return document.querySelector('.modal#login')
    }

    get formElement() {
        return document.querySelector('.modal#login form')
    }
}
